import { GET } from "../axios/apiService";
import { apiEnv } from "../axios/constant";

const activitySlug = apiEnv === "beta" ? "atx-beta" : "atx";
export const getCallActivityOverview = async ({ userId, teamId, query, options }) => {
  let path = "";
  if (userId) path = `/${userId}`;
  else if (teamId) path = `/team/${teamId}`;
  
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/overview${path}${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getCallActivityBestTimes = async ({ userId, teamId, query, options }) => {
  let path = "";
  if (userId) path = `/${userId}`;
  else if (teamId) path = `/team/${teamId}`;

  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/best-times${path}${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getCallActivityNumberPerformance = async ({ userId, teamId, query, options }) => {
  let path = "";
  if (userId) path = `/${userId}`;
  else if (teamId) path = `/team/${teamId}`;
  
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/number-performance${path}${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getActivityFilterCountries = async ({ options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/filters/countries`;
  return GET(url, options);
};

export const getActivityFilterTimezones = async ({ countryCode, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/filters/timezones/${countryCode}`;
  return GET(url, options);
};

export const getCallActivityRepStats = async ({ teamId, query, options }) => {
  let url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/rep-stats`;
  if (teamId) {
    url += `/team/${teamId}`;
  }
  
  if (query) {
    url += `?${query}`;
  }
  
  return GET(url, options);
};
